// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-2017-inaugural-season-jsx": require("gatsby-module-loader?name=component---src-pages-2017-inaugural-season-jsx!/opt/build/repo/src/pages/2017-inaugural-season.jsx"),
  "component---src-pages-2018-chamber-series-jsx": require("gatsby-module-loader?name=component---src-pages-2018-chamber-series-jsx!/opt/build/repo/src/pages/2018-chamber-series.jsx"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-about-js": require("gatsby-module-loader?name=component---src-pages-about-js!/opt/build/repo/src/pages/about.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-press-media-js": require("gatsby-module-loader?name=component---src-pages-press-media-js!/opt/build/repo/src/pages/press-media.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "2017-inaugural-season.json": require("gatsby-module-loader?name=path---2017-inaugural-season!/opt/build/repo/.cache/json/2017-inaugural-season.json"),
  "2018-chamber-series.json": require("gatsby-module-loader?name=path---2018-chamber-series!/opt/build/repo/.cache/json/2018-chamber-series.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "about.json": require("gatsby-module-loader?name=path---about!/opt/build/repo/.cache/json/about.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "press-media.json": require("gatsby-module-loader?name=path---press-media!/opt/build/repo/.cache/json/press-media.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js